import MancubFileBrowser from './FileBrowser'

export default MancubFileBrowser
